import consumer from './consumer';

export const createCallSubscription = (settings, stateRef, socketEvents) => {

  consumer.subscriptions.create('CallChannel', {
    connected() {
    },
  disconnected() {
      // Called when the subscription has been terminated by the server
    },
  received(data) {
    const currentState = stateRef ? stateRef.current : null; // Always access the latest state
    const eventHandler = socketEvents[data.event_type]?.handler;
    if (eventHandler) {
      eventHandler(data, currentState); // Pass the latest state
    }
  }
  });
};
